import { z } from 'zod';
import { USER_ROLES } from './enums';
/**
 * 使用者角色 Zod schema。
 * 合法值：'admin' | 'manager' | 'decider' | 'auditor'
 */
export const userRoleSchema = z.enum(USER_ROLES);
export const loginRequestSchema = z.object({
    username: z.string().min(1),
    password: z.string().min(1),
});
export const forgotPasswordRequestSchema = z.object({
    usernameOrEmail: z.string().min(1),
});
export const resetPasswordRequestSchema = z.object({
    token: z.string().min(1),
    password: z.string().min(8),
});
